import { render, staticRenderFns } from "./website-web-service.vue?vue&type=template&id=94905412&scoped=true&"
import script from "./website-web-service.vue?vue&type=script&lang=js&"
export * from "./website-web-service.vue?vue&type=script&lang=js&"
import style0 from "./website-web-service.vue?vue&type=style&index=0&id=94905412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94905412",
  null
  
)

export default component.exports